import styles from './M31ProductGridCard.module.scss';
import classNames from 'classnames';
import { Picture, LinkButton, LinkButtonProps, Heading } from 'ui/components/1-atoms';
import { IconList, M28ProductOverviewProps } from 'ui/components/3-organisms';
import IconArrowRight from 'ui/icons/icon-arrow-right-web.svg';

export interface M31ProductGridCardProps {
	className?: string;
	image?: Umbraco.Image;
	heading?: M28ProductOverviewProps['heading'];
	facts?: M28ProductOverviewProps['facts'];
	description?: M28ProductOverviewProps['description'];
	url?: string;
	linkText?: string;
	linkAriaLabel?: string;
	buttonStyle?: LinkButtonProps['style'];
}

export const M31ProductGridCard: React.FC<M31ProductGridCardProps> = ({
	className,
	heading,
	linkText,
	image,
	facts,
	description,
	linkAriaLabel,
	url,
	buttonStyle = 'primaryWeb',
}) => {
	return (
		<div className={classNames(styles.M31ProductGridCard, { [styles.M31ProductGridCard___noList]: !facts || facts?.length === 0 }, className)}>
			{image && (
				<Picture
					url={image?.url}
					sizes="100vw"
					properties={{
						altText: image?.properties?.altText,
					}}
					className={styles.M31ProductGridCard_image}
				/>
			)}
			<div className={classNames(styles.M31ProductGridCard_productInfo, styles.M31ProductGridCard_productInfo___top)}>
				{heading && (
					<Heading headingLevel="h3" className={styles.M31ProductGridCard_heading}>
						{heading}
					</Heading>
				)}
				{facts?.length > 0 && <IconList className={styles.M31ProductGridCard_facts} itemList={facts} />}
			</div>
			<div className={classNames(styles.M31ProductGridCard_productInfo, styles.M31ProductGridCard_productInfo___bottom)}>
				{description && <div dangerouslySetInnerHTML={{ __html: description }} className={styles.M31ProductGridCard_description}></div>}
				{linkText && (
					<LinkButton style={buttonStyle} url={url} title={linkAriaLabel} ariaLabel={linkAriaLabel} withBackIcon={<IconArrowRight />}>
						{linkText}
					</LinkButton>
				)}
			</div>
		</div>
	);
};
